import React from "react";

import { templates } from "@reactivated";

import { FlagshipNearestStoresSSR } from "../apps/retail-locator/FlagshipNearestStoresSSR";

export const Template = (
    props: templates.FlagshipNearestStoresTemplate,
): React.JSX.Element => {
    return <FlagshipNearestStoresSSR {...props} />;
};
